import React, { Component } from 'react';
import { Button, Row, Col } from 'reactstrap';

class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      deactive: false
    };
  }

  onChange = status => {
    this.setState(status);
    this.props.onChange(this.state);
  };

  render() {
    const { active, deactive } = this.state;

    return (
      <Row className="filter-btn-container">
        <Col xs={'auto'} className="pr-1">
          <Button
            onClick={() => this.onChange({ active: !active })}
            className={active ? 'active' : ''}
            outline
            color="success"
          >
            A
          </Button>
        </Col>
        <Col xs={'auto'} className="pl-0">
          <Button
            onClick={() => this.onChange({ deactive: !deactive })}
            outline
            color="danger"
            className={deactive ? 'active' : ''}
          >
            D
          </Button>
        </Col>
      </Row>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/views/users/Filters.js